import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { SelectRightSection } from './SelectRightSection.js';

var _excluded = ["styles", "rightSection", "rightSectionWidth", "theme"];
var RIGHT_SECTION_WIDTH = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 44,
  xl: 54
};
function getSelectRightSectionProps(_ref) {
  var styles = _ref.styles,
    rightSection = _ref.rightSection,
    rightSectionWidth = _ref.rightSectionWidth,
    theme = _ref.theme,
    props = _objectWithoutProperties(_ref, _excluded);
  if (rightSection) {
    return {
      rightSection: rightSection,
      rightSectionWidth: rightSectionWidth,
      styles: styles
    };
  }
  var _styles = typeof styles === 'function' ? styles(theme) : styles;
  return {
    rightSectionWidth: theme.fn.size({
      size: props.size,
      sizes: RIGHT_SECTION_WIDTH
    }),
    rightSection: !props.readOnly && !(props.disabled && props.shouldClear) && ( /*#__PURE__*/React__default.createElement(SelectRightSection, _objectSpread2({}, props))),
    styles: _objectSpread2(_objectSpread2({}, _styles), {}, {
      rightSection: _objectSpread2(_objectSpread2({}, _styles === null || _styles === void 0 ? void 0 : _styles.rightSection), {}, {
        pointerEvents: props.shouldClear ? undefined : 'none'
      })
    })
  };
}

export { getSelectRightSectionProps };
//# sourceMappingURL=get-select-right-section-props.js.map
